module.exports = __webpack_public_path__ + "img/suitcase.8aaff3e5.svg";